import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { ADMIN_API } from "../../../common/common";
import { Logout } from "../../../common/Funcation";
import { getTheme, hexToYIQTextColor } from "../../../common/StyleSeter";
import ImageUpload from "../../../components/ImageUpload";
import { getApi, postApi, notifyError, notifyMessage } from "../../../service";
import { addBanner } from "../interface";

function EditDashBanner() {
  const navigate = useNavigate();
  const DD = useSelector((e: any) => e.domainDetails);
  const [isHover, setIsHover] = useState(false);
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const [, updateState] = useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const Validator = useRef(new SimpleReactValidator());
  type BannerLocationState = {
    websiteDomain?: string;
  };
  const location = useLocation();
  const state = location.state as BannerLocationState | null;
  const websiteIdFromState = state?.websiteDomain || "";
  const [websiteDomain, setWebsiteDomain] = useState("");
  const [formData, setFormData] = useState<addBanner>({
    name: "#",
    image: "",
    active: true,
  });
  const { id } = useParams();
  const MODE =
    window.location.pathname.includes("edit-banner") && id ? "EDIT" : "ADD";

  useEffect(() => {
    if (id && MODE === "EDIT") {
      getEditData();
      setFormData({
        ...formData,
      });
    } else if (MODE === "EDIT" && !id) {
      navigate("/banner");
    }
    return () => {};
  }, [id]);

  useEffect(() => {
    const domainId = MODE === "ADD" ? id : websiteIdFromState;
    setWebsiteDomain("");
    if (!domainId) return;
    let cancelled = false;
    getApi({ api: ADMIN_API.SETTING.WEBSITE.GET_DOMAIN })
      .then((response: any) => {
        if (cancelled) return;
        const match = (response.data.data || []).find(
          (item: any) => item?._id === domainId,
        );
        setWebsiteDomain(match?.domain || "");
      })
      .catch(console.error);
    return () => {
      cancelled = true;
    };
  }, [id, websiteIdFromState, MODE]);

  const getEditData = async () => {
    let data: any = {
      api: ADMIN_API.SETTING.BANNER.GET_ONE,
      value: {
        id: id,
      },
    };
    await postApi(data)
      .then(async function (response) {
        const item = response.data.data;
        setFormData({
          name: item.name,
          image: item.image,
          active:
            item.active === true || item.active === "true" || item.active === 1,
        });

        const domainId =
          typeof item?.domain === "object" ? item?.domain?._id : item?.domain;
        if (domainId && !websiteDomain) {
          try {
            const sitesRes: any = await getApi({
              api: ADMIN_API.SETTING.WEBSITE.GET_DOMAIN,
            });
            const match = (sitesRes.data.data || []).find(
              (site: any) => site?._id === String(domainId),
            );
            if (match?.domain) setWebsiteDomain(match.domain);
          } catch (e) {
            console.error(e);
          }
        }
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        if (err.response.data.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const handleInputChange = (e: any) => {
    const { name, value, type } = e.target;
    if (type === "radio") {
      setFormData({
        ...formData,
        [name]: JSON.parse(value),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleImageUpload = (value: string, name: string) => {
    setFormData({ ...formData, [name]: value });
  };

  const getPageData = async () => {
    let data: any = {
      api:
        id && MODE === "EDIT"
          ? ADMIN_API.SETTING.BANNER.UPDATE
          : ADMIN_API.SETTING.BANNER.CREATE,
      value: formData,
    };
    if (id && MODE === "EDIT") {
      data.value.id = id;
    } else {
      data.value.domain = id;
    }

    await postApi(data)
      .then(function (response) {
        console.log(response);
        notifyMessage(response.data.message);
        navigate("/banner");
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        if (err.response.data.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const handleSubmitClick = (e: any) => {
    e.preventDefault();
    if (Validator.current.allValid()) {
      getPageData();
    } else {
      Validator.current.showMessages();
      forceUpdate();
      notifyError("Please fill in all the required fields correctly");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCancelClick = (e: any) => {
    e.preventDefault();
    navigate("/banner");
  };

  return (
    <div
      className="container banking website edit main_wrap"
      style={{ paddingTop: "18px", paddingBottom: "30px" }}
    >
      <div className="top_header" style={{ marginBottom: "15px" }}>
        <div className="top_header_title align-items-center">
          <h5
            className="font-weight-bold mb-1"
            style={{ fontSize: "18px", color: "#212529" }}
          >
            {MODE === "EDIT"
              ? "Update Dashboard Banner"
              : "Add Dashboard Banner"}
          </h5>
        </div>
      </div>

      <div className="edit_body">
        <div
          className="card"
          style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}
        >
          <div className="row ">
            <div className="col-6 p_15">
              {/* Name */}
              <div className="mb-3 p_0 col-12">
                <label htmlFor="name" className="mb_5 d_block">
                  Name:{" "}
                  <span
                    style={{
                      color: "#dc3545",
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  className="form-control"
                  name="name"
                  id="name"
                  type="text"
                  onChange={(e) => handleInputChange(e)}
                  value={formData.name}
                />
                <span className="text-danger">
                  {Validator.current.message("name", formData.name, "required")}
                </span>
              </div>

              {/* Image */}
              <ImageUpload
                label={
                  <span>
                    Image{" "}
                    <span
                      style={{
                        color: "#dc3545",
                      }}
                    >
                      *
                    </span>
                  </span>
                }
                topClass="mb-3 p_0 col-12"
                filename={formData.image}
                name="image"
                setFileName={handleImageUpload}
                validateImage={true}
                domain={websiteDomain}
                error={Validator.current.message(
                  "image",
                  formData.image,
                  "required",
                )}
              />

              {/* Status */}
              <div className="mb-0 p_0 col-12">
                <label style={{ display: "block", marginBottom: 3 }}>
                  Status:
                </label>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "2px",
                  }}
                >
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, active: true }))
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      background: "transparent",
                      border:
                        formData.active === true
                          ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                          : "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: formData.active === true ? 600 : 500,
                      color: "#212529",
                      userSelect: "none",
                      transition: "border-color 0.15s ease",
                    }}
                  >
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border:
                          formData.active === true
                            ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                            : "2px solid #adb5bd",
                        backgroundColor: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        flexShrink: 0,
                      }}
                    >
                      {formData.active === true && (
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              getTheme(DD?.colorSchema)?.backgroundColor ||
                              "#0d6efd",
                            display: "block",
                          }}
                        />
                      )}
                    </span>
                    On
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, active: false }))
                    }
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      background: "transparent",
                      border:
                        formData.active === false
                          ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                          : "1px solid #ced4da",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: formData.active === false ? 600 : 500,
                      color: "#212529",
                      userSelect: "none",
                      transition: "border-color 0.15s ease",
                    }}
                  >
                    <span
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border:
                          formData.active === false
                            ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                            : "2px solid #adb5bd",
                        backgroundColor: "transparent",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxSizing: "border-box",
                        flexShrink: 0,
                      }}
                    >
                      {formData.active === false && (
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor:
                              getTheme(DD?.colorSchema)?.backgroundColor ||
                              "#0d6efd",
                            display: "block",
                          }}
                        />
                      )}
                    </span>
                    Off
                  </button>
                </div>
              </div>
            </div>

            <div className="card_footer">
              <input
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{
                  background: isHover
                    ? hexToYIQTextColor(
                        getTheme(DD?.colorSchema)?.backgroundColor || "#000",
                      )
                    : getTheme(DD?.colorSchema)?.backgroundColor,
                  color: isHover
                    ? getTheme(DD?.colorSchema)?.backgroundColor
                    : hexToYIQTextColor(
                        getTheme(DD?.colorSchema)?.backgroundColor || "#000",
                      ),
                  border: `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor}`,
                  height: "33px",
                }}
                className="btn_black"
                type="submit"
                value="Save"
                onClick={(e) => handleSubmitClick(e)}
              />
              <button
                type="button"
                onClick={(e) => handleCancelClick(e)}
                className="btn btn-sm btn-default"
                style={{ marginBottom: 0 }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditDashBanner;
